<template>
  <div class="vkb_nak vkb_nak_slv vkb_nak_private_unfallversicherung">
    <div id="unfall" class="content_container_8">
      <div class="wrapper-spacing small-12 medium-12 large-12 columns">
        <div class="row">
          <div class="large-12 columns">
            <h2 class="top-headline h3">Private Unfallversicherung</h2>

            <div
              v-for="(accordion, index) in accordions"
              :key="accordion.id"
              :class="`row item item${ accordion.id }`"
            >
              <div class="large-12 columns" @click="() => openAccordion(index)">
                <div class="highlight info-container">
                  <div class="info-icon">
                    <slv-icon :icon-name="accordion.slv_icon" />
                  </div>

                  <div v-if="accordion.id !== 3" class="triangle-top">
                    <div class="triangle"/>
                    <img :src="hasAssetPath ? assetPath('images/plus.png') : imgPlus">
                  </div>

                  <div v-if="accordion.id !== 1" class="triangle-bottom">
                    <div class="triangle"/>
                  </div>

                  <h4>
                    <img :src="hasAssetPath ? assetPath('images/arrow.png') : imgArrow">
                    {{ accordion.name }}
                  </h4>

                  <ul class="square">
                    <li v-for="(item, index_) in accordion.items" :key="index_">
                      {{ item.name }}
                    </li>
                  </ul>

                  <span>{{ accordion.id }}</span>
                </div>
              </div>

              <div v-if="openedAccordion === index" class="large-12 columns unfall-description">
                <div class="unfall-description-inner">
                  <div class="unfall-description-content">
                    <h3>{{ accordion.description }}</h3>

                    <div v-for="(item, index_) in accordion.items" :key="index_">
                      <p><b>{{ item.name }}</b></p>
                      <p>{{ item.text }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SlvIcon from '@/components/common/slv-icon';
import logic from './logic';

export default {
  name: 'private_unfallversicherung_slv',

  components: {
    SlvIcon
  },

  mixins: [
    logic
  ],

  data: () => ({
    imgPlus: require('@/assets/images/plus.png'),
    imgArrow: require('@/assets/images/arrow.png')
  })
};
</script>



// WEBPACK FOOTER //
// src/apps/private_unfallversicherung/slv.vue